import { Component } from '@angular/core';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { RewardsService } from 'src/app/services/rewards/rewards.service';
import { TimeService } from 'src/app/services/time-service/time.service';

@Component({
  selector: 'app-risk-free-bet-risk',
  templateUrl: './risk-free-bet-risk.component.html',
  styleUrls: ['./risk-free-bet-risk.component.scss'],
})
export class RiskFreeBetRiskComponent {
  public bonusArray: any = [];
  public showTable: boolean = false;
  public showNoResults: boolean = false;
  public showForfeitConfirm: boolean = false;
  public hasBeenForfeit: boolean = false;
  public error = null;
  public success:boolean = false;
  public successBonusObj;

  constructor(
    private rewardsService: RewardsService,
    private events: EventsService,
    public successMessageService: SuccessMessageService,
    public utils: TimeService,
  ) {
    this.successMessageService.clearMessage();
  }

  ionViewDidEnter() {
      this.loadRFBBonusesOptIn();
  }

  private loadRFBBonusesOptIn = () => {
      this.rewardsService.callRFBBonusOptIn({ only_active: true }).subscribe({
          next: (response: any) => {
              if (response && !!response.result) {
                  this.bonusArray = response.payload;
                  if (this.bonusArray.length > 0) {
                      this.events.publish("event:RFBbonusStatus", {RFBBonus: this.bonusArray[0]});
                      this.showTable = true;
                      this.showNoResults = false;
                  }
                  else {
                      this.showTable = false;
                      this.showNoResults = true;
                  }
              }
          },
          error: (error) => {
              this.showTable = false;
              this.error = error;
          }
    });
  }

  public onShowRFBForfeitConfirm() {
      this.events.publish("event:RFBbonusForfeit", {forefitAction: this.bonusArray[0], forefitActionType: 'Intention'});
      this.showForfeitConfirm = true;
  }

  public onCancelRFBForfeitBonus() {
      this.events.publish("event:RFBbonusForfeit", {forefitAction: this.bonusArray[0], forefitActionType: 'Cancel'});
      this.showForfeitConfirm = false;
  }

  public onRFBForfeitBonus() {
      this.error = null;

      this.rewardsService.callRFBBonusForfeit(this.bonusArray[0].id).subscribe({
          next: (response: any) => {
              if (response && !!response.result) {
                  this.successMessageService.setMessage('Your Risk Free Bet bonus was forfeited.');
                  this.showForfeitConfirm = false;
                  this.hasBeenForfeit = true;
                  this.events.publish("event:RFBbonusForfeit", {forefitAction: this.bonusArray[0], forefitActionType: 'Confirm'});
                  this.loadRFBBonusesOptIn();
              }
          },
          error: (error) => {
              switch (error.getErrorCode().toUpperCase()) {
                  case 'CLOSE_OPENED_GAMES':
                      error.setErrorMessage('Please close all opened games in order to forfeit the bonus.');
                      break;
                  case 'RESOLVE_SPORTS_GAME':
                      error.setErrorMessage('A sport event reserved funds from this bonus - please wait for its resolution first.');
                      break;
                  case 'RESOLVE_SAVED_GAME':
                      error.setErrorMessage('A saved game reserved funds from this bonus - please resolve it first.');
                      break;
                  default:
                      error.setErrorMessage(error.getErrorMessage());
                      break;
              }

              this.error = error;
          }
    });
  }
}
